import React from "react";
import "./Helditems.css"; // CSS für Styling
import Footer from "./Footer";

const Helditems = () => {
  // Liste der Helditems mit Bild und Beschreibung
  const items = [
    {
      id: 1,
      image: "https://poke-meta.com/static/images/items/arrow.png",
      description: "When a teammate's Pokémon Projection is defeated, self damage is increased by 5% and attack speed is increased by 10%"
    },
    {
      id: 2,
      image: "http://poke-meta.com/static/images/items/metronom.png",
      description: "Each time a teammate Pokémon Projection uses a normal move, it increases the damage of its own move by 4%"
    }
    ,
    {
      id: 3,
      image: "http://poke-meta.com/static/images/items/chargingcharm.png",
      description: "After causing 12 instances of damage, +80% Damage."
    }
    ,
    {
      id: 4,
      image: "http://poke-meta.com/static/images/items/choicescarf.png",
      description: "Recover 8 points of move progress every second."
    }
    ,
    {
      id: 5,
      image: "http://poke-meta.com/static/images/items/claw.png",
      description: "+150% Move Damage. Begin every battle with full move progress points."
    }
    ,
    {
      id: 6,
      image: "http://poke-meta.com/static/images/items/cloak.png",
      description: "+30% ATK SPD, +10% ATK, +10% SP ATK. Immune to all hindrance effects."
    }
    ,
    {
      id: 7,
      image: "http://poke-meta.com/static/images/items/coin.png",
      description: "+20% Damage. After winning a battle, gain 1 additional point."
    }
    ,
    {
      id: 8,
      image: "http://poke-meta.com/static/images/items/drain.png",
      description: "+25% Lifesteal, +10% ATK, +10% SP ATK, +100 DEF, +100 SP DEF"
    }
    ,
    {
      id: 9,
      image: "http://poke-meta.com/static/images/items/egg.png",
      description: "+20% Damage Reduction. After losing a battle, gain 2 additional trainer XP."
    }
    ,
    {
      id: 10,
      image: "http://poke-meta.com/static/images/items/focus.png",
      description: "+45% HP regeneration, +40% damage. The lower the holder’s HP, gain an increasing damage reduction of up to 30%."
    }
    ,
    {
      id: 11,
      image: "http://poke-meta.com/static/images/items/glasses.png",
      description: "+40% SP ATK"
    }
    ,
    {
      id: 12,
      image: "http://poke-meta.com/static/images/items/incense.png",
      description: "+200 HP, +150 DEF, +150 SP DEF. Causing damage will apply additional damage equal to 1% of the target’s HP every second and reduce HP recovery by 30%. (No details on time length of HP recovery debuff.)"
    }
    ,
    {
      id: 13,
      image: "http://poke-meta.com/static/images/items/king.png",
      description: "+10% ATK, +20% ATK SPD. Causing damage to the opponent will reduce the target’s defense by 240 for 3 seconds."
    }
    ,
    {
      id: 14,
      image: "http://poke-meta.com/static/images/items/leftover.png",
      description: "+580 HP. Recover 5% of the holder’s HP every 3 seconds. (Leftovers does not stack with itself.)"
    }
    ,
    {
      id: 15,
      image: "http://poke-meta.com/static/images/items/muscle.png",
      description: "+30% ATK SPD. Each normal attack will cause damage equal to 3% of the target’s HP. This effect has a 0.3 second internal CD."
    }
    ,
    {
      id: 16,
      image: "http://poke-meta.com/static/images/items/rapidfire.png",
      description: "After 3 normal attacks, gain +50% ATK SPD. When damaging a shielded opponent, increase ATK SPD by 15% for 6 seconds."
    }
    ,
    {
      id: 17,
      image: "http://poke-meta.com/static/images/items/rescue.png",
      description: "+150 DEF, +150 SP DEF. Recover 4 points of move progress every second. Increase ALL HP recovery and shielding effects of self AND allies by 30%."
    }
    ,
    {
      id: 18,
      image: "http://poke-meta.com/static/images/items/rocky.png",
      description: "+300 HP +300 DEF. When the holder takes damage from a normal attack, reflect 3% of pre mitigation damage in an area of effect around the holder. 1 second internal CD."
    }
    ,
    {
      id: 19,
      image: "http://poke-meta.com/static/images/items/smoke.png",
      description: "+10% Damage, +20% ATK SPD. When the holder reaches 50% maximum HP or lower, the holder will enter an invulnerable state for 2.5 seconds. This will also cause all targets to lose targeting on the holder."
    }
    ,
    {
      id: 20,
      image: "http://poke-meta.com/static/images/items/specs.png",
      description: "+70% Move Damage (Excludes “special moves”.)"
    }
    ,
    {
      id: 21,
      image: "http://poke-meta.com/static/images/items/spoon.png",
      description: "+10% SP ATK, +20% ATK SPD.  Causing damage to the opponent will reduce the target’s special defense by 240 for 3 seconds."
    }
    ,
    {
      id: 22,
      image: "http://poke-meta.com/static/images/items/vest.png",
      description: "+800 HP. Gain a shield equal to 32% of the holder’s maximum HP that lasts for 3 seconds, and refreshes every 5 seconds."
    }
    ,
    {
      id: 23,
      image: "http://poke-meta.com/static/images/items/weakness.png",
      description: "Each time you receive damage, gain a 5% damage increase and a 5% damage reduction, stacking up to 5 times and lasting for 4 seconds."
    }
    ,
    {
      id: 24,
      image: "http://poke-meta.com/static/images/items/tm.png",
      description: "Unlocks Pokemon Ultimate Attack."
    },
    {
      id: 25,
      image: "https://poke-meta.com/static/images/items/bangle.png",
      description: "+30% ATK SPD. Causing damage will apply additional damage equal to 1% of the target’s HP every second and reduce HP recovery by 30%. (No details on time length of HP recovery debuff.)"
    }
    ,
    {
      id: 26,
      image: "http://poke-meta.com/static/images/items/barrier.png",
      description: "+300 HP, +100 DEF, +100 SP DEF. Each time the holder uses a move, a shield equal to 18% of the holder’s maximum HP will be given to the ally with the lowest HP percentage."
    }
  ];

  return (
    <div className="helditems-container">
      <h1 className="helditems-title">🛡 Helditems</h1>

      {items.map((item) => (
        <div key={item.id} className="helditem-box">
          <img src={item.image} alt="Helditem" className="helditem-image" />
          <p className="helditem-description">{item.description}</p>
        </div>
      ))}
      <Footer />
    </div>
  );
};

export default Helditems;
